import Vue from "vue";
import Router from "vue-router";
import Header from "./layout/starter/StarterHeader.vue";
import Footer from "./layout/starter/StarterFooter.vue";
import Starter from "./views/Starter.vue";
import Contact from "./views/Contact.vue";
import Terms from "./views/Terms.vue";
import Privacy from "./views/Privacy.vue";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "starter",
      components: {
        header: Header,
        default: Starter,
        footer: Footer
      }
    },
    {
      path: "/contact",
      name: "contact",
      components: {
        header: Header,
        default: Contact,
        footer: Footer
      }
    },
    {
      path: "/terms",
      name: "terms",
      components: {
        header: Header,
        default: Terms,
        footer: Footer
      }
    },
    {
      path: "/privacy",
      name: "privacy",
      components: {
        header: Header,
        default: Privacy,
        footer: Footer
      }
    }
  ]
});
